import React from 'react'
import forOwn from 'mout/object/forOwn'

export default function EliminationBars ({eliminations}) {
  let bars = []
  const styles = {
    composite: {width: '325px', float: 'left', top: '9px', left: '97px', position: 'absolute'},
    english: {width: '175px', top: '56px', left: '58px', position: 'absolute'},
    math: {width: '175px', top: '56px', right: '58px', position: 'absolute'},
    reading: {width: '175px', top: '95px', left: '58px', position: 'absolute'},
    science: {width: '175px', top: '95px', right: '58px', position: 'absolute'},
  }
  const denom = {
    composite: 3,
    english: 3,
    math: 4,
    reading: 4,
    science: 4,
  }
  forOwn(eliminations, (val, key) => {
    const nameLC = key.toLowerCase()
    const perc = Math.round(val / denom[nameLC] * 100)
    bars.push(
      <div className={nameLC} style={styles[nameLC]} key={`elim-${nameLC}`}> 
        <h3>
          {key}
          <span style={{color: '#999'}}>{`(On a Scale of 0-${denom[nameLC]})`}</span>
        </h3>
        <div className='redGreenBar'>
          <span className='scoreCircle' style={{marginLeft: `${perc}%`}}>
            <span className='score'>{Math.round(val * 10) / 10}</span>
          </span>
        </div>
      </div>
    )
  })


  return (
    <div className="skill-graphs">
      <div className="reports ">
        {bars}
      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/TestTaking/EliminationBars.js